import { FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withAttrs } from 'utils/react';

export const ErrorText = styled(withAttrs(FormHelperText, { error: true }))`
  text-align: center;
`;
